export default "__VITE_ASSET__DaWyDE$b__"